module.exports = __webpack_public_path__ + "img/engagement-active.ce06b804.svg";